<template>
  <div class="md-layout">
    <md-empty-state
      class="md-accent"
      md-icon="warning"
      md-label="505"
      md-description="Url Expired">
    </md-empty-state>
  </div>
</template>

<script>
import eventBus from '../bus'
  export default {
    name: 'EmptyStateRounded', 
    mounted: function(){
        eventBus.$emit('isLoading', false);
    }
  }
</script>